import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const MaskLines = ({ lines, className = "", delay = 0.1, lineClass = "" }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span
          className={`block ${lineClass}`}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1, ease, delay: delay + i * 0.12 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const Reveal = ({ children, className = "", delay = 0, y = 32, as = "div" }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, ease, delay }}
    >
      {children}
    </M>
  );
};

export const Eyebrow = ({ children, light = false }) => (
  <span className={`inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] ${light ? "text-lime-300" : "text-emerald-700"}`}>
    <span className={`h-1.5 w-1.5 rounded-full ${light ? "bg-lime-300" : "bg-lime-500"}`} />
    {children}
  </span>
);
